/* =========================================
   WAZIR GLOBAL TRACKING FILE
   ========================================= */

/* ---------- Google Tag Manager ---------- */
(function(w,d,s,l,i){
  w[l]=w[l]||[];
  w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
  var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),
  dl=l!='dataLayer'?'&l='+l:'';
  j.async=true;
  j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
  f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-5MWTR7H4');


/* ---------- Google Tag (gtag.js) ---------- */
(function(){
  var s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=GT-NFJB8H4C";
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', 'GT-NFJB8H4C');
})();


/* ---------- Contentsquare ---------- */
(function(){
  var s = document.createElement("script");
  s.src = "https://t.contentsquare.net/uxa/79baa2b4e3444.js";
  s.defer = true;
  document.body.appendChild(s);
})();